import axios from '../axios'
import qs from 'qs';
import { getToken } from '@/utils/auth';

//查询足迹
export const query = ()=>{
	let data = {
		token:getToken(),
	};
	data = qs.stringify(data);
	return axios({
		url:'/review/fp.query.php',
		method:'post',
		data
	})
}

//修改足迹
export const modify = (data)=>{
	data.token = getToken();
	data = qs.stringify(data);
	return axios({
		url:'/review/fp.modify.php',
		method:'post',
		data
	});
}

//删除足迹
export const del = (data)=>{
	data.token = getToken();
	data = qs.stringify(data);
	return axios({
		url:'/review/fp.delete.php',
		method:'post',
		data
	});
}

//分享足迹
export const share = (data)=>{
	data.token = getToken();
	data = qs.stringify(data);
	return axios({
		url:'/review/fp.share.web.php',
		method:'post',
		data
	});
}

//查询分享足迹
export const shareQuery = (data)=>{
	data = qs.stringify(data);
	return axios({
		url:'/review/fp.share.web.query.php',
		method:'post',
		data
	});
}



// WEBPACK FOOTER //
// ./src/provider/api/review.js